import { Injectable } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { combineLatest } from 'rxjs';

declare global {
    interface Window {
        userpilot?: any;
    }
}
@Injectable({ providedIn: 'root' })
export class Angulartics2Userpilot {
    constructor(private angulartics2: Angulartics2) {
        combineLatest([
            this.angulartics2.setUsername,
            this.angulartics2.setUserProperties
        ]).subscribe(([username, properties]) =>
            this.identify(username, properties)
        );
    }

    startTracking(): void {
        this.angulartics2.pageTrack
            .pipe(this.angulartics2.filterDeveloperMode())
            .subscribe(x => this.pageTrack(x.path));
        this.angulartics2.eventTrack
            .pipe(this.angulartics2.filterDeveloperMode())
            .subscribe(x => this.eventTrack(x.action, x.properties));
    }

    pageTrack(path: string) {
        try {
            // do nothing
        } catch (e) {
            if (!(e instanceof ReferenceError)) {
                throw e;
            }
        }
    }

    eventTrack(action: string, properties: any) {
        try {
            // do nothing
        } catch (e) {
            if (!(e instanceof ReferenceError)) {
                throw e;
            }
        }
    }

    identify(
        userId: string | { userId: number | string },
        properties: Record<string, string>
    ) {
        try {
            if (userId == null) {
                window.userpilot?.anonymous();
            } else if (typeof userId === 'object') {
                window.userpilot?.identify(userId.userId, {
                    name: `${properties?.firstName} ${properties?.lastName}`,
                    email: properties.email
                });
            } else {
                window.userpilot?.identify(userId, {
                    name: `${properties?.firstName} ${properties?.lastName}`,
                    email: properties.email
                });
            }
        } catch (e) {
            if (!(e instanceof ReferenceError)) {
                throw e;
            }
        }
    }
}
